import { render } from "./Configs.vue?vue&type=template&id=c7d61960&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"

import "./Configs.vue?vue&type=style&index=0&id=c7d61960&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d61960"]])

export default __exports__